







import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Helpers
import { parseBase64 } from '@/helpers/image'

@Component
export default class ImageViewer extends Vue {
  imageSrc: string = null
  isLoading = false

  @Getter('token') token

  @Prop(Number) imageId !: number

  @Prop({ type: Boolean, default: false }) reload: boolean

  @Watch('imageId', { immediate: true })
  async fetchImage() {
    await this.loadImage()
  }

  @Watch('reload')
  async reloadImage(reload) {
    if (reload) {
      await this.loadImage()
    }
  }

  async loadImage() {
    if (!this.imageId) {
      return
    }
    try {
      this.isLoading = true
      const res = await this.$api.image.getImage(this.token, this.imageId)
      this.imageSrc = parseBase64(res.data)
    } finally {
      this.isLoading = false
    }
  }
}
